import moment from 'moment';
import { createSelector } from 'reselect';
import { orderBy } from 'lodash';

const getRssFeed = state => state.rssFeed.entities;
const getRssFeedOrderBy = state => state.rssFeedTableState.rssFeedOrderBy;

const getMappedRssFeed = (feeds, feedsOrderBy) => {
  const { orderDir, keyName } = feedsOrderBy;

  const mappedFeeds = feeds.map(feed => {
    const { updatedAt, audienceName, url, active, status } = feed;
    const formattedUpdatedAt = moment(updatedAt).format('MM/DD/YYYY');
    const formattedAudienceName = audienceName || '';
    const formatedActive = active ? 'Active' : 'Draft';
    const formattedStatus = `${formatedActive} ${status}`;
    const formattedUrl = url || '';
    return {
      ...feed,
      formattedStatus,
      formattedAudienceName,
      formattedUrl,
      formattedUpdatedAt,
    };
  })

  return orderBy(mappedFeeds, [feed => feed[keyName].toLowerCase()], [orderDir]);
}

export const rssFeedSelector = createSelector(
  [getRssFeed, getRssFeedOrderBy],
  getMappedRssFeed,
)
